import React from 'react';
import UserImg from '../assets/images/user.png';
import BankImg from '../assets/images/bank.png';

const WalletDashboardStatic = () => {
    return (
        <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
            <style>
                {`
                .wallet-header {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                }

                .user-img {
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                }

                .user-name {
                    font-size: 24px;
                    font-weight: bold;
                }

                .user-welcome {
                    color: #555;
                }

                .wallet-actions {
                    margin-top: 20px;
                    display: flex;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .action-btn {
                    padding: 10px 20px;
                    border-radius: 8px;
                    color: white;
                    font-weight: bold;
                    cursor: pointer;
                    border: none;
                }

                .gradient-yellow {
                    background: linear-gradient(to right, #facc15, #f97316);
                }

                .gradient-blue {
                    background: linear-gradient(to right, #6366f1, #8b5cf6);
                }

                .gradient-green {
                    background: linear-gradient(to right, #10b981, #059669);
                }

                .gear-icon {
                    background: #ddd;
                    color: #333;
                }

                .wallet-history {
                    margin-top: 30px;
                    background: white;
                    padding: 20px;
                    border-radius: 12px;
                    box-shadow: 0 2px 10px #eee;
                }

                .history-entry {
                    display: flex;
                    justify-content: space-between;
                    padding: 10px 0;
                    border-bottom: 1px solid #eee;
                }

                .amount {
                    font-weight: bold;
                }

                .amount.positive {
                    color: green;
                }

                .amount.negative {
                    color: red;
                }

                .bank-info {
                    display: flex;
                    align-items: center;
                    margin-top: 30px;
                    gap: 15px;
                }

                .bank-info img {
                    width: 64px;
                    height: 64px;
                }

                .bank-name {
                    font-weight: bold;
                    font-size: 18px;
                }

                .bank-acc {
                    color: #666;
                    font-size: 14px;
                }

                .balance-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
                    gap: 20px;
                    margin-top: 30px;
                }

                .balance-card {
                    background: white;
                    border-radius: 12px;
                    padding: 20px;
                    box-shadow: 0 2px 10px #eee;
                }

                .card-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .card-title {
                    font-weight: bold;
                    color: #5b21b6;
                }

                .card-sub {
                    color: #555;
                }

                .card-icon {
                    font-size: 24px;
                    background: #ddd;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .card-amount {
                    font-size: 20px;
                    font-weight: bold;
                    margin-top: 10px;
                }

                .wallet-summary {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    margin-top: 40px;
                    background: white;
                    padding: 20px;
                    border-radius: 12px;
                    box-shadow: 0 2px 10px #eee;
                }

                .summary-icon {
                    font-size: 32px;
                }

                .summary-label {
                    color: #555;
                }

                .summary-title {
                    font-weight: bold;
                    font-size: 18px;
                }

                .summary-value {
                    font-size: 20px;
                    font-weight: bold;
                    color: #2563eb;
                }

                .withdraw-btn {
                    margin-top: 10px;
                    padding: 8px 16px;
                    background: linear-gradient(to right, #6366f1, #8b5cf6);
                    color: white;
                    border: none;
                    border-radius: 8px;
                    font-weight: bold;
                    cursor: pointer;
                }
                `}
            </style>

            <div className="wallet-header">
                <img src={UserImg} alt="User" className="user-img" />
                <div>
                    <h1 className="user-name">User Name</h1>
                    <p className="user-welcome">Welcome, here is a brief summary of your account.</p>
                </div>
            </div>

            <div className="wallet-actions">
                <button className="action-btn gradient-yellow">Transfer AED → THB</button>
                <button className="action-btn gradient-blue">Transfer THB → AED</button>
                <button className="action-btn gradient-green">Add to Wallet</button>
                <button className="action-btn gear-icon">⚙️</button>
            </div>

            <div className="wallet-history">
                <h2>Transaction History</h2>
                <div className="history-entry">
                    <span>Withdrawal to Bank</span>
                    <span className="amount negative">-500</span>
                </div>
                <div className="history-entry">
                    <span>Transfer from AED</span>
                    <span className="amount positive">+1000</span>
                </div>
            </div>

            <div className="bank-info">
                <img src={BankImg} alt="Bank" />
                <div>
                    <p className="bank-name">Bank of Example</p>
                    <p className="bank-acc">Account Number (****1234)</p>
                </div>
            </div>

            <div className="balance-grid">
                {[
                    { label: "BAHT", code: "THB", icon: "฿" },
                    { label: "DIRHAM", code: "AED", icon: "د.إ" },
                    { label: "DOLLAR", code: "USD", icon: "💵" },
                    { label: "EURO", code: "EUR", icon: "€" }
                ].map((currency, i) => (
                    <div className="balance-card" key={i}>
                        <div className="card-header">
                            <div>
                                <p className="card-title">{currency.label}</p>
                                <p className="card-sub">{currency.code}</p>
                            </div>
                            <div className="card-icon">{currency.icon}</div>
                        </div>
                        <p className="card-amount">{currency.icon} 1000.00</p>
                    </div>
                ))}
            </div>

            <div className="wallet-summary">
                <div className="summary-icon">💰</div>
                <div>
                    <p className="summary-label">Available</p>
                    <p className="summary-title">Wallet Balance</p>
                    <p className="summary-value">USD 1,500.00</p>
                    <button className="withdraw-btn">Withdraw to Bank</button>
                </div>
            </div>
        </div>
    );
};

export default WalletDashboardStatic;
